import { DwHttpClient } from '../../../http/client';
// import { APP_API_URL } from '../../../config/system.config';
import { Injectable, inject } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { DwLoggingService } from '../../../log/logging.service';
import { DwDapHttpErrorHandler } from './dap-http-error-handler';
import { DwUserService } from '../../../auth/user.service';
import { DwSystemConfigService } from '../../../config/config.service';


@Injectable()
export class DwDapHttpClient extends DwHttpClient {
  constructor(
    private systemConfig: DwSystemConfigService,
    private userService: DwUserService,
    private dapHttpError: DwDapHttpErrorHandler) {
    super();

    this.systemConfig.get('apiUrl').subscribe(url => this.api = url);

  }

  protected get defaultHeaders(): { [header: string]: string | string[] }  {
    const token = this.userService.getUser('token') ? this.userService.getUser('token') : '';
    return {
      'token': token
    };
  }

  protected responseIntercept(body: any): any {
    if (body && body.response) {
      return body.response;
    } else {
      return body;
    }
  }

  protected errorHandler(event: any): void {
    if (event.error && event.error.status) {
      this.dapHttpError.handlerError(event);
    }
  }
}
